import { render, staticRenderFns } from "./GCheckbox.vue?vue&type=template&id=85ddf918&"
import script from "./GCheckbox.vue?vue&type=script&lang=js&"
export * from "./GCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./GCheckbox.vue?vue&type=style&index=0&id=85ddf918&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports